import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getTherapistPatientsFunctionalityQueryKey = () => ["getTherapistPatientsFunctionality"] as const;

export const useGetTherapistPatientsFunctionality = () => {
  const client = useApiClient();

  return useQuery(getTherapistPatientsFunctionalityQueryKey(), () => client.getTherapistPatientsFunctionality());
};
